export var defaultOptions = {
  showDismissButton: true,
  dismissOnRouteChange: true,
  compact: false
};